const state = {
    bookList: null,
    deptList: null,
    tagList: null
};

// getters
const getters = {
    bookList: state => state.bookList,
    deptList: state => state.deptList,
    tagList: state => state.tagList,
};

// mutations
const mutations = {
    setBookList(state, value) {
        state.bookList = value;
    },
    setDeptList(state, value) {
        state.deptList = value;
    },
    setTagList(state, value) {
        state.tagList = value;
    },
};

const actions = {

};

export default {
    state,
    getters,
    mutations,
    actions
}
